import React from 'react';
import { Filter, ChevronDown, DownloadIcon, SparklesIcon } from 'lucide-react';
interface ToolbarProps {
  filtersOpen: boolean;
  setFiltersOpen: (open: boolean) => void;
  hasActiveFilters: boolean;
}
export function Toolbar({
  filtersOpen,
  setFiltersOpen,
  hasActiveFilters
}: ToolbarProps) {
  return <div className="flex-shrink-0 border-b border-geniac-border" data-id="element-223">
      <div className="flex items-center justify-between px-5 py-2.5" data-id="element-224">
        {/* Left: filter toggle */}
        <div className="flex items-center relative" data-id="element-225">
          <button onClick={() => setFiltersOpen(!filtersOpen)} className={`p-2 rounded-md transition-colors ${filtersOpen || hasActiveFilters ? 'text-geniac-accent bg-geniac-accent/10' : 'text-geniac-muted hover:text-geniac-text hover:bg-geniac-hover'}`} title="Toggle filters" data-id="element-226">
            <Filter className="w-5 h-5" data-id="element-227" />
          </button>
          {hasActiveFilters && <span className="absolute -top-0.5 -right-0.5 w-4 h-4 bg-geniac-accent text-geniac-bg text-[10px] font-bold rounded-full flex items-center justify-center" data-id="element-228">
              !
            </span>}
        </div>

        {/* Center: Ask AI button */}
        <button className="flex items-center gap-2 bg-geniac-accent hover:bg-geniac-accent/90 text-geniac-bg font-semibold text-sm px-5 py-2 rounded-lg transition-colors shadow-lg shadow-geniac-accent/20" data-id="element-229">
          <SparklesIcon className="w-4 h-4" data-id="element-230" />
          Ask AI
        </button>

        {/* Right: Export */}
        <button className="flex items-center gap-2 text-sm text-geniac-accent border border-geniac-border hover:border-geniac-accent/50 rounded-lg px-4 py-2 transition-colors" data-id="element-231">
          <DownloadIcon className="w-4 h-4" data-id="element-232" />
          Export
          <ChevronDown className="w-3 h-3" data-id="element-233" />
        </button>
      </div>
    </div>;
}